/**
 * Blank thumbnail with diagonal slash for "no texture" material option.
 */
function FloorPlanMaterialNoneThumbnail() {
  return (
    <span className="floor-plan-material-none-thumb" aria-hidden>
      <svg viewBox="0 0 48 48" className="floor-plan-material-none-thumb-svg">
        <line x1="6" y1="42" x2="42" y2="6" />
      </svg>
    </span>
  );
}

export default FloorPlanMaterialNoneThumbnail;
